import React from 'react';
import './style.scss';
import Button from '../../../../../controls/button';
import SVGTwitter from '../../../../../../assets/images/icons/twitter';
import SVGDiscord from '../../../../../../assets/images/icons/discord';

const LandingFooterInfo = () => (
  <section id='info' className='landing-footer-section-info'>
    <h2 className='lfsi-wording'>info desk</h2>
    <h4 className='lfsi-text-block body-1'>
      FOR GAME OR NFT RELATED QUESTIONS DM US ON TWITTER OR DISCORD:
    </h4>
    <div className='lfsi-social-icons-block'>
      <a
        href='https://nifty-hands.com/twitter'
        className='lfsi-social-icon'
        target='_blank'
      >
        <SVGTwitter />
      </a>
      <a
        href='https://nifty-hands.com/discord'
        className='lfsi-social-icon'
        target='_blank'
      >
        <SVGDiscord />
      </a>
      {/*<a
        href='https://nifty-hands.com/instagram'
        className='lfsi-social-icon'
        target='_blank'
      >
        <SVGInstagram height={55} />
      </a>*/}
    </div>
    <h4 className='lfsi-text-block body-1'>
      FOR ANY OFFICIAL STUFF, WRITE AN OFFICIAL E-MAIL:
    </h4>
    <Button color='default' variant='outlined' pixelFont>
      🖕@nifty-hands.com
    </Button>
  </section>
);

export default LandingFooterInfo;
